import React, { useState } from 'react'
import styles from './GLifosMetadata.module.scss'
import { Collapse } from 'react-bootstrap';
import CitationMetadata from '../CitationMetadata/CitationMetadata';

export default function GLifosMetadata(props) {
    const { metadata, author_citation } = props;
    const [titlebtn, setTitlebtn] = useState('hide');
    const [show, setShow] = useState(true);
    //console.log(metadata);
    const [IndexShow, setIndexShow] = useState(0);
    const [chmetadata, setChmetadta] = useState(
        metadata ? (
            metadata.length === 1 ? metadata[0] : metadata[0]
        ) : (
            null
        )
    );

    const handleChannelMetadata = (index) => {
        setChmetadta(metadata[index]);
        setIndexShow(index);
    };

    const generateCitation = (metadata) => {
        // Formatear los autores
        const authors = metadata.authors.map(author => {
            const [name, institution] = author.split(', ');

            return `${name}`;
        }).join(', ');

        // Formatear la cita en APA
        const citation = `${authors}. / ${metadata.year}. ${metadata.title}. The Journal of Private Enterprise, ${metadata.volume}(${metadata.number}).`;

        return citation;
    };

    const generateCitation2 = ({ author_citation, metadata }) => {
        return (
            <div className={styles.result}>
                {author_citation.map((author, index) => (
                    <span key={index}>
                        {author.lastname}, {author.name}
                        {index < author_citation.length - 1 ? '; ' : ' / '}
                    </span>
                ))}
                {metadata.year}. "{metadata.title}" <em>The Journal of Private Enterprise</em> {metadata.volume}({metadata.number}) : {metadata.pages}
            </div>
        );
    };

    const handleShowMetadata = () => {
        if (show) {
            setTitlebtn('show');
            setShow(false);
        } else {
            setTitlebtn('hide');
            setShow(true);
        }
    }

    if (metadata?.length === 1) {
        const arr = Object.entries(metadata[0]);
        return (
            <div className={`${styles.main}`}>
                <div className={`${styles.maintitle}`}>
                    <div className={`${styles.title}`}>Metatada</div>
                    <div className={`${styles.show}`}
                        onClick={handleShowMetadata}
                        aria-controls="example-collapse-text"
                        aria-expanded={show}
                    >[{titlebtn}]</div>
                </div>
                <Collapse in={show}>
                    <div id="example-collapse-text">
                        <div className={`${styles.meta}`}>
                            {
                                arr.map((item, index) =>
                                (
                                    //If item[1] is not '' or null or 'unauthorized' then show it
                                    item[1] !== '' && item[1] !== null && (
                                        <div className={`${styles.item}`} key={index}>
                                            <div className={`${styles.title}`}>
                                                {item[0]}:
                                            </div>
                                            <div className={`${styles.value}`}>
                                                {
                                                    Array.isArray(item[1]) ? (
                                                        item[1].map((item, index) => (
                                                            <div className={`${styles.value}`} key={index}>
                                                                {item}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        typeof item[1] === 'object' ? (
                                                            Object.entries(item[1]).map((item, index) => {
                                                                return (
                                                                    <div className={`${styles.value}`}>
                                                                        {item[0]}: {item[1]}
                                                                    </div>
                                                                )
                                                            })
                                                        ) : (
                                                            item[1]
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                    )
                                    /* console.log(typeof item[1], item[1]) */
                                )
                                )
                            }
                        </div>
                        <div className={`${styles.citation}`}>
                            <div className={`${styles.title}`}>
                                Citation:
                            </div>
                            <CitationMetadata author_citation={author_citation} metadata={metadata[0]} />
                        </div>
                    </div>
                </Collapse>
            </div>
        )
    } else {
        if (metadata) {
            return (
                <div className={`${styles.main}`}>
                    <div className={`${styles.options}`}>
                        {
                            metadata.map((item, index) => {
                                //const arr = Object.entries(item);
                                return (
                                    index !== IndexShow && (
                                        <a onClick={() => handleChannelMetadata(index)}>
                                            {'['}show {item.lang ? item.lang : item.language} metadata{']'}
                                        </a>
                                    )
                                )
                            })
                        }
                    </div>
                    {
                        chmetadata && (
                            <div className={`${styles.main}`}>
                                {
                                    Object.entries(chmetadata).map((item, index) =>
                                    (
                                        <div className={`${styles.item}`} key={index}>
                                            <div className={`${styles.title}`}>
                                                {item[0]}:
                                            </div>
                                            <div className={`${styles.value}`}>
                                                {
                                                    Array.isArray(item[1]) ? (
                                                        item[1].map((item, index) => (
                                                            <div className={`${styles.value}`} key={index}>
                                                                {item}
                                                            </div>
                                                        ))
                                                    ) : (
                                                        typeof item[1] === 'object' ? (
                                                            Object.entries(item[1]).map((item, index) => {
                                                                return (
                                                                    <div className={`${styles.value}`}>
                                                                        {item[0]}: {item[1]}
                                                                    </div>
                                                                )
                                                            })
                                                        ) : (
                                                            item[1]
                                                        )
                                                    )
                                                }
                                            </div>
                                        </div>
                                        /* console.log(typeof item[1], item[1]) */
                                    )
                                    )
                                }
                            </div>
                        )
                    }
                </div>
            )
        } else (
            <div>
                No metadata
            </div>
        )

    }
}

/* 
item[0] !== 'value' && item[1].value !== null && item[1].value !== '' && item[1].value !== 'unauthorized' ? (
                        <div className={`${styles.item}`}>
                            <div className={`${styles.title}`}>
                                {item[0]}:
                            </div>
                            <div className={`${styles.value}`}>
                                {item[1].value}
                            </div>
                        </div>
                    ) : (
                        item[1].value === '' && (
                            item[1].keyword && (
                                <div className={`${styles.item}`}>
                                    <div className={`${styles.title}`}>
                                        {item[0]}:
                                    </div>
                                    <div className={`${styles.value}`}>
                                        {Array.isArray(item[1].keyword) ? (
                                            item[1].keyword.map((item, index) => {
                                                return (
                                                    <div className={`${styles.value}`}>
                                                        {item.value}
                                                    </div>
                                                )
                                            })
                                        ) : (
                                            <div className={`${styles.value}`}>
                                                {item[1].keyword.value}
                                            </div>

                                        )}
                                    </div>
                                </div>
                            )
                        )
                    )

*/
